import type { ReactNode } from "react";

import type { UUID } from "@/core/types";

import { useUpdateNoteAddendum } from "../../api/mutations/useUpdateNoteAddendum";

import { AddendumForm } from "./AddendumForm";

type EditAddendumProps = {
  addendumId: UUID;
  children?: ReactNode;
  credentials: string | undefined;
  defaultValue: string;
  noteId: UUID;
  onCancel: () => void;
  onSuccess: () => void;
  patientId: UUID;
  signature: string | undefined;
};

export function EditAddendum({
  addendumId,
  children,
  credentials,
  defaultValue,
  noteId,
  onCancel,
  onSuccess,
  patientId,
  signature,
}: EditAddendumProps) {
  const { isPending, mutate } = useUpdateNoteAddendum({ onSuccess });

  return (
    <AddendumForm
      defaultValue={defaultValue}
      isPending={isPending}
      mutate={(addendum) =>
        mutate({ addendum, addendumId, credentials, noteId, patientId, signature })
      }
      onCancel={onCancel}
    >
      {children}
    </AddendumForm>
  );
}
